import styled, { css } from 'styled-components';
import { Label } from '../../../ui/atoms/Checkbox/style';

export const SessionBlockContainer = styled.section`
  border-radius: 16px;
  background-color: #eff5fb;
  padding: 24px;
  display: flex;
  flex-direction: column;
  //row-gap: 24px;
  counter-reset: alphabetic;

  &:not(:last-child) {
    margin-bottom: 24px;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    margin-inline: -16px;
    padding: 24px 16px;
    border-radius: 0;
  }
`;

export const SessionTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  @media ${({ theme }) => theme.device.mobileL} {
    flex-direction: column;
    align-items: start;
    row-gap: 24px;
  }
`;

export const SessionTitle = styled.div`
  display: flex;
  align-items: center;
  column-gap: 24px;

  @media ${({ theme }) => theme.device.mobileL} {
    flex-direction: column;
    align-items: start;
    row-gap: 16px;
    padding-bottom: 24px;
    border-bottom: 1px solid #e3e3e3;
    width: 100%;
  }
`;

export const ActivityCardWrapper = styled.div`
  //margin-bottom: 32px;
`;

export const ActivityCard = styled.div`
  border-radius: 12px;
  background-color: #ffffff;
  padding: 24px 24px 40px;
  display: flex;
  flex-direction: column;
  //row-gap: 24px;

  &.is-copy {
    position: relative;
    margin-left: 46px;

    &::before {
      content: '';
      top: -24px;
      bottom: 0;
      left: -24px;
      width: 2px;
      position: absolute;
      background-size: 2px 16px;
      background-image: linear-gradient(
        to bottom,
        #22408b 0 50%,
        transparent 50% 100%
      );
      background-repeat: space;
    }

    &:not(.is-copy ~ .is-copy)::before {
      top: 0;
    }
  }

  &:not(:last-child) {
    margin-bottom: 24px;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    padding: 16px 16px 24px;
  }
`;

export const ActivityTitle = styled.div`
  display: flex;
  align-items: center;
  column-gap: 24px;
  margin-bottom: 24px;

  .is-multi {
    counter-increment: alphabetic;

    &::after {
      content: ' ' counter(alphabetic, upper-alpha);
    }
  }

  @media ${({ theme }) => theme.device.mobileL} {
    flex-direction: column;
    align-items: start;
    row-gap: 8px;
  }
`;

export const Infos = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 40px;
  row-gap: 48px;

  &:not(:last-child) {
    margin-bottom: 40px;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    display: flex;
    flex-direction: column;
    row-gap: 24px;

    &:not(:last-child) {
      margin-bottom: 32px;
    }
  }
`;

export const TimeContainer = styled.div`
  display: contents;

  @media ${({ theme }) => theme.device.mobileL} {
    display: flex;
    column-gap: 56px;
  }
`;

export const QuizButton = styled.div`
  display: flex;
  align-items: center;
  column-gap: 32px;

  @media ${({ theme }) => theme.device.mobileL} {
    flex-direction: column;
    align-items: start;
    row-gap: 8px;
  }
`;

export const AttendanceRegister = styled.div`
  margin-top: 32px;
`;

export const AttendanceRegisterTitle = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  margin-bottom: 24px;

  @media ${({ theme }) => theme.device.mobileL} {
    row-gap: 16px;
    margin-bottom: 32px;
  }
`;

export const SortingWrapper = styled.div`
  margin-block: 24px;
  margin-left: 12px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  > div:last-child {
    height: 48px;
  }
`;

const gridTempCols = css`
  --padding-inline: 32px;

  display: grid;
  column-gap: 24px;
  padding-inline: var(--padding-inline);

  @media ${({ theme }) => theme.device.mobileL} {
    --padding-inline: 0;
  }
`;

export const LegendAndCard = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !['gridTemplateColumns', 'gridTemplateRows'].includes(prop),
})`
  &:not(:last-child) {
    margin-bottom: 8px;
  }

  > * {
    grid-template-columns: ${({ gridTemplateColumns }) => gridTemplateColumns};

    @media ${({ theme }) => theme.device.mobileL} {
      grid-template-rows: ${({ gridTemplateRows }) => gridTemplateRows};
    }
  }

  @media ${({ theme }) => theme.device.mobileL} {
    display: flex;
    padding: 24px 16px;
    background-color: white;
    border-bottom: 1px solid transparent;
    border-image: linear-gradient(
        to right,
        transparent 16px,
        #8b8b8b 16px calc(100% - 16px),
        transparent calc(100% - 16px)
      )
      1;

    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
`;

export const Legend = styled.div`
  ${gridTempCols}
  margin-bottom: 16px;

  > *:first-child {
    margin-left: calc(var(--padding-inline) * -1);
  }

  @media ${({ theme }) => theme.device.mobileL} {
    row-gap: 16px;
    grid-template-columns: 90px;
    align-items: center;
    margin-bottom: 0;

    > *:first-child {
      margin-left: 0;
    }
  }
`;

export const UserCardWrapper = styled.div`
  //margin-bottom: 24px;
`;

export const UserCard = styled.div`
  ${gridTempCols}
  align-items: center;
  height: 73px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);

  button {
    margin-left: auto;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    row-gap: 16px;
    grid-template-columns: 1fr;
    text-align: end;
    width: 100%;

    //remove card style
    height: auto;
    border-radius: 0;
    background: none;
    box-shadow: none;

    //checkbox
    ${Label} {
      margin-left: auto;
      margin-top: 0; //override
    }
  }
`;

export const ConfirmWrapper = styled.div`
  margin: 24px 0 16px;
  display: flex;
  justify-content: flex-end;
`;

export const AddAttempt = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 16px 24px;
  margin-top: 24px;
  border-radius: 4px;
  border: 0.5px dashed #036;

  button {
    min-width: fit-content;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    flex-direction: column;

    button {
      margin-left: auto;
    }
  }
`;
